document.addEventListener("DOMContentLoaded", (event) => {
  let collection_tab_filter = document.querySelectorAll('input[data-collection-filter]');
  collection_tab_filter.forEach(function(filter_btn){
    filter_btn.onchange = function(){
      let param = this.dataset.filterParamName;
      let value = this.value;
      let filter_check = document.querySelector(`input[name="${param}"][value="${value}"]`);
      filter_check.click();
    };
  });
  document.addEventListener('filter:product:grid:updated',function(){
    updateFilterTabs();
    enableQuickAddToCart();
  });
  updateFilterTabs();
  function updateFilterTabs(){
    collection_tab_filter.forEach(function(filter_btn){
      let param = filter_btn.dataset.filterParamName;
      let value = filter_btn.value;
      let filter_check = document.querySelector(`input[name="${param}"][value="${value}"]`);
      let parent = filter_check.parentNode;
      let label_text = parent.querySelector('span[aria-hidden="true"]').textContent.toUpperCase();

      // check disable status
      (filter_check.disabled) ? filter_btn.disabled = true : filter_btn.disabled = false;

      // Update label text
      let filter_btn_label = filter_btn.nextElementSibling;
      filter_btn_label.querySelector('span').textContent = label_text;

      // Update check active status
      (filter_check.checked) ? filter_btn.checked = true : filter_btn.checked = false;
    });
    // View All Button Active Status
    let facet_remove_btn = document.querySelector('.active-facets');
    let filter_view_all_tab = document.querySelector('.filter-tab-view-all a');
    if(facet_remove_btn.childElementCount > 1){
      if(filter_view_all_tab.classList.contains("active")){
        filter_view_all_tab.classList.remove("active")
      }
    }else{
      filter_view_all_tab.classList.add("active");
    }
  }

  function enableQuickAddToCart() {
    const plusIcons = document.querySelectorAll('.variant-selector-plus .plus-icon-area');
    const closeButtons = document.querySelectorAll('.q-atc-close-btn');

    plusIcons.forEach(icon => {
      icon.addEventListener('click', function () {
        const selectedProductId = icon.getAttribute('q-atc-data-id');
        if (!selectedProductId) return;

        const quickAddWrappers = document.querySelectorAll('.q-atc-desk-wrapper');
        quickAddWrappers.forEach(wrapper => wrapper.classList.remove('active'));

        const targetProduct = document.querySelector(`[data-product-id="${selectedProductId}"]`);
        if (targetProduct) {
          targetProduct.classList.add('active');
        }
      });
    });

    closeButtons.forEach(btn => {
      btn.addEventListener('click', function () {
        const parent = btn.parentElement;
        if (parent) {
          parent.classList.remove('active');
        }
      });
    });
  }

});

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener('filter:product:grid:updated', function () {
    filterProductHide();
  });

  function filterProductHide() {
    setTimeout(() => {
      if (window.location.href.includes("filter")) {
        const hiddenItems = document.querySelectorAll('#product-grid .grid__item.hide-product');
        hiddenItems.forEach(item => {
          item.classList.remove('hide-product');
        });
      }
    }, 500);
  }

  filterProductHide();
});

document.addEventListener("DOMContentLoaded", function () {
  var sectionWrapper = document.querySelector('[data-collection-grid-section]');
  if (!sectionWrapper) return;

  var sectionId = sectionWrapper.getAttribute('data-section-id');
  var section = document.querySelector('#shopify-section-' + sectionId);
  if (!section) return;

  var subFilterKeys = section.querySelectorAll('.sub-filter-key');
  subFilterKeys.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.getAttribute('filter-key');

      document.querySelectorAll('.filter-menu .sub-filter-key').forEach(function (el) {
        el.classList.remove('active');
      });

      btn.classList.add('active');

      var multiItems = document.querySelectorAll('#block .multi_category');
      multiItems.forEach(function (item) {
        var values = item.getAttribute('multi_category') || '';

        // Reset Slick slider position
        document.querySelectorAll('.grid-image-slider').forEach(function(slider) {
          if (slider.slick && typeof slider.slick.setPosition === 'function') {
            slider.slick.setPosition();
          }
        });

        if (values.includes(key)) {
          if (!item.classList.contains('hide-product')) {
            item.style.display = '';
          }
        } else {
          item.style.display = 'none';
        }
      });
    });
  });

  var mobileLabels = section.querySelectorAll('aside menu-drawer .mobile-facets__main .mobile-facets__item label');
  mobileLabels.forEach(function (label) {
    label.addEventListener('click', function () {
      document.querySelectorAll('.mobile-facets__checkbox:checked');
    });
  });
});
